<template>
	<div class="border-top">
		<div class="p-x-20 p-y-16 w-100 d-flex align-items-center" :id="id">
			<SOInputOnOff :checkboxes="paketKedaluarsa" @selected="selected" :checked="filterItem.paketKedaluarsa"/>
		</div>
		<div class="separator"></div>
	</div>
</template>

<script>
import {mapGetters} from "vuex";
import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOInputOnOff from "@/so-components/global/input/SOInputOnOff";

const paketKedaluarsa = (paket = "") => ({
	name: "paket-kedaluarsa",
	data: [
		{
			id: "fpk-1",
			value: "0",
			title: "Tampilkan <b>" + paket + " Paket</b> kedaluarsa",
			checked: false,
			titleBold: false,
		},
	]
})

export default {
	name: "SOFilterPaketKedaluarsa",
	components: {
		SOFilterTitle,
		SOInputOnOff,
	},
	props: {
		id: String,
	},
	computed: {
		...mapGetters("filterGlobalModule", {
			filterItem: "getFilterItem"
		}),
		...mapGetters("depositModule", {
			listPaketDepositData: "getListPaketDeposit",
		})
	},
	data() {
		return {
			paketKedaluarsa: paketKedaluarsa(),
		}
	},
	mounted() {
		this.paketKedaluarsa = paketKedaluarsa(this.listPaketDepositData.data.jumlah_paket_nonaktif)
	},
	methods: {
		selected(val) {
			let temp = this.filterItem
			temp.paketKedaluarsa = val
			this.$store.commit("filterGlobalModule/setFilterItem", temp)
		}
	}
}
</script>